module.exports = __webpack_public_path__ + "static/media/AwsDoc1.04dfc776.png";